import { createStyles, makeStyles } from '@material-ui/core';

export const useLabelStyles = makeStyles(() =>
    createStyles({
        root: {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 500,
            color: '#000000',
            fontFamily: 'Poppins'
        },
        hasError: {
            color: '#EF4F57'
        },
        required: {
            fontWeight: 600,
            color: '#EAB464',
            fontSize: 16
        }
    })
);
